import React from 'react';
import { Card, CardContent } from './ui/card';
import { Hand, Smartphone, Wrench, Zap, MousePointer, Shield } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
  {
    icon: MousePointer,
    title: 'Virtual Touchpad',
    description: 'Control your entire screen with a floating touchpad. Move the cursor anywhere and tap to click.',
    color: 'from-blue-500 to-blue-600',
    bgColor: 'bg-blue-50',
    iconColor: 'text-blue-600'
  },
  {
    icon: Hand,
    title: 'One-Handed Operation',
    description: 'Perfect for large phones. Access the entire screen comfortably with just one hand.',
    color: 'from-purple-500 to-purple-600',
    bgColor: 'bg-purple-50',
    iconColor: 'text-purple-600'
  },
  {
    icon: Shield,
    title: 'Damaged Screen Support',
    description: 'Continue using your phone even with a partially damaged or non-responsive screen.',
    color: 'from-green-500 to-green-600',
    bgColor: 'bg-green-50',
    iconColor: 'text-green-600'
  },
  {
    icon: Zap,
    title: 'Quick Action Buttons',
    description: 'Pre-defined buttons for common gestures: swipe up, down, left, right, and long press.',
    color: 'from-orange-500 to-orange-600',
    bgColor: 'bg-orange-50',
    iconColor: 'text-orange-600'
  },
  {
    icon: Wrench,
    title: 'Fully Customizable',
    description: 'Customize touchpad size, position, sensitivity, and appearance to match your preferences.',
    color: 'from-pink-500 to-pink-600',
    bgColor: 'bg-pink-50',
    iconColor: 'text-pink-600'
  },
  {
    icon: Smartphone,
    title: 'Lightweight & Fast',
    description: "Minimal battery and memory usage. Optimized performance for smooth operation.",
    color: 'from-indigo-500 to-indigo-600',
    bgColor: 'bg-indigo-50',
    iconColor: 'text-indigo-600'
  }];


  return (
    <section id="features" className="py-20 sm:py-28 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            Features
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to control your Android device with ease and precision
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) =>
          <Card
            key={index}
            className="group border-2 border-gray-100 hover:border-indigo-200 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 bg-white overflow-hidden">

              <CardContent className="p-8 space-y-4">
                {/* Icon */}
                <div className={`w-16 h-16 ${feature.bgColor} rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                  <feature.icon className={`w-8 h-8 ${feature.iconColor}`} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-indigo-600 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Hover indicator */}
                <div className={`w-0 group-hover:w-full h-1 bg-gradient-to-r ${feature.color} transition-all duration-300 rounded-full`}></div>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </section>);

};

export default FeaturesSection;